export const HEADING_FONTS = [
  { value: "Cormorant Garamond", label: "Cormorant Garamond (default)" },
  { value: "Playfair Display", label: "Playfair Display" },
  { value: "DM Serif Display", label: "DM Serif Display" },
  { value: "Lora", label: "Lora" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Raleway", label: "Raleway" },
  { value: "Outfit", label: "Outfit" },
  { value: "Great Vibes", label: "Great Vibes (script)" },
];
export const BODY_FONTS = [
  { value: "Outfit", label: "Outfit (default)" },
  { value: "Lora", label: "Lora" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Raleway", label: "Raleway" },
  { value: "Plus Jakarta Sans", label: "Plus Jakarta Sans" },
  { value: "Cormorant Garamond", label: "Cormorant Garamond" },
];

export interface PageStyle { heading_font?: string; body_font?: string; accent_color?: string; bg_color?: string; text_color?: string }
export const DEFAULT_STYLE: Required<PageStyle> = { heading_font: "Outfit", body_font: "Outfit", accent_color: "#b45309", bg_color: "#ffffff", text_color: "#1c1917" };
export const STYLE_KEYS = ["accent_color", "bg_color", "text_color"] as (keyof PageStyle)[];

export const ACCENT_PRESETS = ["#b45309", "#dc2626", "#15803d", "#1a56db", "#7c3aed", "#0f766e", "#be185d", "#111827"];
export const BG_PRESETS = ["#ffffff", "#faf7f2", "#f5f5f4", "#0b0d14", "#14532d", "#7f1d1d", "#1e3a8a"];

export function styleVars(p: PageStyle): React.CSSProperties {
  const s = { ...DEFAULT_STYLE, ...Object.fromEntries(Object.entries(p || {}).filter(([, v]) => v)) } as Required<PageStyle>;
  return {
    ["--heading-font" as any]: "'Outfit', sans-serif",
    ["--body-font" as any]: "'Outfit', sans-serif",
    ["--accent" as any]: s.accent_color,
    ["--page-bg" as any]: s.bg_color,
    ["--page-text" as any]: s.text_color,
    ["--page-muted" as any]: isDark(s.bg_color) ? "rgba(255,255,255,0.6)" : "#78716c",
    ["--page-border" as any]: isDark(s.bg_color) ? "rgba(255,255,255,0.18)" : "#e7e5e4",
  };
}

export function isDark(hex?: string) {
  if (!hex || hex.length < 7) return false;
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
}

export const textToHtml = (t?: string) => (t ? t.split(/\n{2,}|\n/).map((l) => `<p>${l.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</p>`).join("") : "");
export const htmlToText = (h?: string) => (h ? h.replace(/<\/(p|li|h[1-6]|div)>/g, "\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/\n{2,}/g, "\n").trim() : "");
